"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnderwritingApiClient = void 0;
var amorphic_1 = require("@haventech/amorphic");
var apollo_fetch_1 = require("apollo-fetch");
var UwClientAppCtx_1 = require("./UwClientAppCtx");
var gqlEndpoint = '/gql';
var UnderwritingApiClient = /** @class */ (function (_super) {
    __extends(UnderwritingApiClient, _super);
    function UnderwritingApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnderwritingApiClient_1 = UnderwritingApiClient;
    Object.defineProperty(UnderwritingApiClient.prototype, "log", {
        get: function () {
            return UnderwritingApiClient_1.logger || (UnderwritingApiClient_1.logger = UwClientAppCtx_1.UwClientAppCtx.get.logger(this.constructor.name));
        },
        enumerable: false,
        configurable: true
    });
    UnderwritingApiClient.new = function (underwritingUrl) {
        return new this().init(underwritingUrl);
    };
    UnderwritingApiClient.prototype.init = function (apiUrl) {
        var _this = this;
        var underwritingUrl = apiUrl || UwClientAppCtx_1.UwClientAppCtx.get.config.underwritingUrl;
        if (!underwritingUrl) {
            this.log.error('init', 'Initializing', { name: '', message: 'underwritingUrl is not defined!' });
        }
        else {
            this.log.info('init', 'Initializing', { underwritingUrl: underwritingUrl });
        }
        this.gqlUri = underwritingUrl + gqlEndpoint;
        this.apolloFetch = (0, apollo_fetch_1.createApolloFetch)({ uri: this.gqlUri });
        this.apolloFetch.use(function (_a, next) {
            var _b, _c;
            var request = _a.request, options = _a.options;
            var context = (_c = (_b = _this.log.havenLogger).getHeaderContextFromLocalStorage) === null || _c === void 0 ? void 0 : _c.call(_b);
            options.headers = __assign(__assign({}, options.headers), context);
            return next();
        });
        return this;
    };
    UnderwritingApiClient.prototype.buildQuery = function (obj) {
        if (obj instanceof Array && obj.length > 0) {
            obj = obj[0];
        }
        var keys = Object.keys(obj);
        if (keys.length === 0) {
            return '';
        }
        var query = '{';
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            query = "".concat(query, " ").concat(key);
            if (obj[key] !== null && typeof obj[key] === 'object' && !(obj[key] instanceof Date)) {
                query = "".concat(query, " ").concat(this.buildQuery(obj[key]));
            }
        }
        return "".concat(query, " }");
    };
    UnderwritingApiClient.prototype.gqlFetch = function (query, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.apolloFetch({ query: query, variables: variables })
                        .then(function (result) {
                        //GraphQL errors and extensions are optional
                        if (result.errors && result.errors.length > 0) {
                            var errorMessages = result.errors.reduce(function (messages, error) {
                                var message = error.message;
                                messages += "".concat(message, "\n");
                                _this.log.error('gqlFetch', "GQL Error: ".concat(message), { name: '', message: messages });
                                return messages;
                            }, '');
                            throw new Error("GQL error was found:\n ".concat(errorMessages));
                        }
                        return result;
                    })
                        .catch(function (error) {
                        throw new Error("Cannot fetch from GQL endpoint: ".concat(error));
                    })];
            });
        });
    };
    UnderwritingApiClient.prototype.underwritePolicy = function (request, query) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query underwriting($request: UnderwritingRequest) {\n           underwriting(request: $request) ".concat(this.buildQuery(query), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.notifyStatusChange = function (request, query) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query notifyStatusChange($request: StatusChangeRequest) {\n           notifyStatusChange(request: $request) ".concat(this.buildQuery(query), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getFollowUps = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query followUps($request: FollowUpRequest) {\n            followUps(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.submitFollowUps = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                query = "query submitFollowUps($request: SubmitFollowUpRequest) {\n            submitFollowUps(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(query, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getRateClassFlatExtras = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query rateClassFlatExtras($request: RateClassRequest) {\n            rateClassFlatExtras(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getAdverseActions = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query adverseActions($request: AdverseActionRequest) {\n            adverseActions(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getReflexiveModuleStatuses = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query reflexiveModuleStatuses($request: ReflexiveModuleStatusRequest) {\n            reflexiveModuleStatuses(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getCurrentStage = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query currentStage($request: CurrentStageRequest) {\n            currentStage(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getExamData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query examData($request: ExamDataRequest) {\n            examData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getReflexiveRxData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query reflexiveRxData($request: ReflexiveRxDataRequest) {\n            reflexiveRxData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getSIEligibility = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query fetchSIEligibility($request: SIEligibilityRequest) {\n            fetchSIEligibility(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getExamStatus = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query examStatus($request: ExamStatusRequest) {\n            examStatus(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getManualUWStatus = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query manualUWStatus($request: ManualUWStatusRequest) {\n            manualUWStatus(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getUnderwritingType = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query underwritingType($request: UnderwritingTypeRequest) {\n            underwritingType(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getMultiTypeRateClass = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query multiTypeRateClass($request: RateClassRequest) {\n            multiTypeRateClass(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getIdCheckData = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query idCheckData($request: IdCheckDataRequest) {\n            idCheckData(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    UnderwritingApiClient.prototype.getDeclineReasons = function (request, responseQuery) {
        return __awaiter(this, void 0, void 0, function () {
            var req;
            return __generator(this, function (_a) {
                req = "query declineReasons($request: DeclineReasonsRequest) {\n            declineReasons(request: $request) ".concat(this.buildQuery(responseQuery), "\n        }");
                return [2 /*return*/, this.gqlFetch(req, { request: request })];
            });
        });
    };
    var UnderwritingApiClient_1;
    UnderwritingApiClient = UnderwritingApiClient_1 = __decorate([
        (0, amorphic_1.supertypeClass)({ toClient: false, toServer: false })
    ], UnderwritingApiClient);
    return UnderwritingApiClient;
}(amorphic_1.Supertype));
exports.UnderwritingApiClient = UnderwritingApiClient;
//# sourceMappingURL=UnderwritingApiClient.js.map